import { getSnapshotAppDefaultInfo } from "helpers/globalContext/globalInfoSnapshot";

interface IAppDefaultFlagsType {
    [flag: string]: any;
}

/**
 * The raw, untyped app-default dictionary the webforms handler inlines on the page.
 *
 * `btAdminAuthProjectX` is declared on the typed `AppDefaultInfo` snapshot, so this is only the
 * second half of the `??` in `isBTAdminAuthProjectXEnabled` below: the pre-resolution fallback for
 * a webforms-hosted page, where the master page still inlines the global. SPA routes no longer
 * load JScriptGlobalsHandler.ashx, so there the dictionary is absent and the snapshot is the only
 * source. Goes away with webforms.
 */
// eslint-disable-next-line @typescript-eslint/no-deprecated -- see above; bootstrap-only, owned by 282448 / 283956
const btJScriptGlobals = window.btJScriptGlobals;
const flagsDictOrUndef: IAppDefaultFlagsType | undefined =
    btJScriptGlobals && btJScriptGlobals.appDefaultFlags;

/**
 * Read lazily rather than captured at module scope: the snapshot is only populated once
 * `AppProvider` resolves, and `redirectToLoginPage` can fire on a 401 before that.
 */
export const isBTAdminAuthProjectXEnabled = (): boolean =>
    Boolean(
        getSnapshotAppDefaultInfo()?.btAdminAuthProjectX ?? flagsDictOrUndef?.btAdminAuthProjectX,
    );
